<template>
  <Catalogs
    title="Нарекания исполнителей"
    create-text="Новый"
    :fetch-data="fetchData"
    :route-create="'WorkerComplaintAdd'"
    :route-edit="'WorkerComplaintEdit'"
    :route-view="'WorkerComplaintView'"
    :route-path="'/worker_complaints'"
    :can-edit="canEditCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "WorkerComplaints",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getWorkerComplaints(data);
    },
    canEditCatalogs() {
      return this.hasPermission([PERM.CATALOG_WORKER_COMPLAINTS_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerComplaints/WorkerComplaints.vue